import { redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

/**
 * Sprint 23.6 — la verifica è il primo passo obbligatorio.
 * Utilizzato come `beforeLoad` nelle route Chef della dashboard
 * (profilo, foto, annunci, richieste): se l'utente non è ancora
 * verificato lo reindirizza alla pagina di verifica.
 *
 * Le route sotto `_authenticated/` girano con `ssr: false`, quindi
 * possiamo usare il client supabase del browser direttamente.
 */
export async function requireVerifiedChef() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;
  // Sprint 25.2 — gli admin non devono mai entrare nel funnel Chef.
  const { data: isAdmin } = await supabase.rpc("has_role", { _user_id: user.id, _role: "admin" });
  if (isAdmin) {
    throw redirect({ to: "/dashboard/admin" });
  }
  const { data: chef } = await supabase
    .from("chefs")
    .select("verified_badge")
    .eq("user_id", user.id)
    .maybeSingle();
  if (!chef?.verified_badge) {
    throw redirect({ to: "/dashboard/verifica" });
  }
}